const routes = [
  {
    path: 'cellwise-downtime-dashboard', // cellwise-downtime-dashboard
    component: () => import(/* webpackChunkName: "cellwise-downtime-dashboard" */ './views/Index.vue'),
    meta: {
      permissionRequired: true,
    },
    children: [
      {
        path: '',
        name: 'cellwiseDowntimeDashboard', // cellwiseDowntimeDashboard
        component: () => import(/* webpackChunkName: "cellwise-downtime-dashboard" */ './views/cellwiseDowntimeDashboard.vue'),
      },
    ],
  },
];

export default routes;
